export const SECTION_CARD_SX = { mb: 3, p: 2 };
